import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { FormArray, FormBuilder, FormGroup, Validators } from "@angular/forms";
import { finalize, first } from "rxjs/operators";
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from "@angular/animations";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { Employee } from "../../core/model/employee/employee";
import { Bank } from "../../core/model/bank";
import { Direction } from "../../core/model/direction";
import { Departement } from "../../core/model/departement";
import { Annee } from "../../core/model/annee";
import { Conges } from "../../core/model/conges";
import { BankService } from "../../core/service/bank.service";
import { DirectionService } from "../../core/service/direction.service";
import { DepartementService } from "../../core/service/departement.service";
import { EmployeeService } from "../../core/service/employee.service";
import { AnneeService } from "../../core/service/annee.service";
import { CongesService } from "../../core/service/conges.service";
import { AddCongesComponent } from "../add-conges/add-conges.component";
import { EditCongesComponent } from "../edit-conges/edit-conges.component";
import { CreateEmployee } from "../../core/model/employee/create-employee";

@Component({
  selector: "app-add-user",
  templateUrl: "./add-user.component.html",
  styleUrls: ["./add-user.component.scss"],

  //
  animations: [
    trigger("detailExpand", [
      state("collapsed", style({ height: "0px", minHeight: "0" })),
      state("expanded", style({ height: "*" })),
      transition(
        "expanded <=> collapsed",
        animate("225ms cubic-bezier(0.4, 0.0, 0.2, 1)")
      ),
    ]),
  ],
  //
})
export class AddUserComponent implements OnInit {
  pressButton: Boolean = false;
  form: FormGroup;

  erreur: string = null;

  public file: File;
  public photo: string | ArrayBuffer;
  public photoContentType: String;

  newemployee: CreateEmployee = new CreateEmployee();

  directions: Direction[];
  departements: Departement[];
  banks: Bank[];

  constructor(
    private _router: Router,
    private _bankService: BankService,
    private _drectionService: DirectionService,
    private _departementService: DepartementService,
    private _employeeService: EmployeeService,
    private fb: FormBuilder
  ) {
    this.createForm();
  }

  createForm() {
    this.form = this.fb.group({
      active: [null, Validators.compose([Validators.required])],
      matricule: [null, Validators.compose([Validators.required])],
      poste: [null, Validators.compose([Validators.required])],
      firstname: [null, Validators.compose([Validators.required])],
      lastname: [null, Validators.compose([Validators.required])],
      businessEmail: [null, Validators.compose([Validators.required])],
      businessPhone: [null, Validators.compose([Validators.required])],
      username: [null, Validators.compose([Validators.required])],
      direction: [null, Validators.compose([Validators.required])],
      departement: [null, Validators.compose([Validators.required])],
      bank: [null, Validators.compose([Validators.required])],
      password: [null, Validators.compose([Validators.required])],
      codeAgent: [null, Validators.compose([Validators.required])],
      initiale: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this.getDirections();
    this.getBanks();
  }

  getDirections() {
    this._drectionService.getAllDirections().subscribe(
      (data) => {
        this.directions = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  changeDepartements() {
    let directionid = this.form.controls["direction"].value.id;
    this.getDepartementsByDirection(directionid);
  }

  getDepartementsByDirection(directionid) {
    this._departementService.getDepartementsByDirection(directionid).subscribe(
      (data) => {
        this.departements = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getBanks() {
    this._bankService.getAllBanks().subscribe(
      (data) => {
        this.banks = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  changeListener($event) {
    this.readThis($event.target);
  }

  readThis(inputValue: any): void {
    this.file = inputValue.files[0];
    var myReader: FileReader = new FileReader();

    myReader.onloadend = (e) => {
      this.newemployee.photo = myReader.result.toString().split(",")[1];
      this.newemployee.photoContentType = this.file.type;
    };
    myReader.readAsDataURL(this.file);
  }

  save(): void {
    this.pressButton = true;
    this._employeeService
      .add(this.newemployee)
      .pipe(
        first(),
        finalize(() => {
          this.pressButton = false;
        })
      )
      .subscribe(
        (data) => {
          this.goToList();
        },
        (error) => {
          console.log(error);
          this.erreur = error.error.message;
        }
      );
  }

  cancel(): void {
    this.goToList();
  }

  private goToList(): void {
    this._router.navigateByUrl("/parametrage/user");
  }
}
